export default __webpack_public_path__ + "static/media/screen5.757b5124.png";